import { AxiosResponse } from 'axios';
import { ContactDto, ContactControllerApi } from 'client';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useContactServices = () => {
	const services = new ContactControllerApi();
	

	const sendContact = async (contact: any): Promise<AxiosResponse<any>> => {

		//temporary object to be used in an api for test (MUST CHANGE)
		let embeddedContact : ContactDto = {
			email: contact.email,
			firstName: contact.firstName,
			lastName: contact.lastName,
			nationalId: contact.nationalId.replaceAll('.', ''),
			phone: contact.phone,
			touchPointSelected: contact.touchPointSelected
		}
		return services.createContactUsingPOST(
			getTokenFromStorage(),
			embeddedContact
		);
	};

	return { sendContact } as const;
};
